<template>
    <form ref="form">
        <div class="d-flex align-items-center mb-3">
            <h3 class="text-3 font-weight-bold mr-auto mb-0">
                <span>My Vehicles</span>
            </h3>
            <button v-if="customer && success" @click="showUserDetails = !showUserDetails" type="button"
                    class="btn btn-outline-primary py-1 px-4 shadow-none">
                <template v-if="!showUserDetails">
                    <svg class="svg-icon mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"/>
                    </svg>
                    {{ customer.firstName }}
                </template>
                <small v-else><i  class="fa fa-times"></i> Hide info</small>
            </button>
        </div>

        <div v-if="message" class="bg-primary text-center text-white px-3 py-3 my-3">
            {{ message }}
        </div>

        <transition name="fade">
            <div v-if="showUserDetails && customer && success" class="bg-primary rounded text-white px-3 py-3 my-3">
                Name : <strong>{{ customer.firstName }}</strong> <br>
                Last Name : <strong>{{ customer.surname }}</strong> <br>
                National Id : <strong>{{ customer.nationalId }}</strong> <br>
                Phone : <strong>{{ customer.msisdn }}</strong> <br>
            </div>
        </transition>

        <div class="list-group list-group-flush mb-3" v-if="success">
           <div style="height: 260px" class="overflow-auto border rounded-lg">
               <div v-for="item in vehicles" class="list-group-item list-group-item-action border-0">
                   <div class="d-flex align-items-center">
                       <svg class="svg-icon mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z" /></svg>
                       <div class="px-2 py-1">
                           <strong>{{ item.vrn }}</strong>
                       </div>
                   </div>
               </div>
           </div>
            <a href="#" @click.prevent="showAddNewVehicle = true" class="btn btn-primary mt-3">
                <i class="fa fa-plus mr-2"></i>
                <span>Add vehicle</span>
            </a>
        </div>

        <div class="text-center mt-3">
            <router-link v-if="success" :to="`/zinara/vehicles?id=${this.$route.query.id}`"
                         :class="['btn btn-success btn-block px-4' , form.loading || loading ? 'btn-loading' : '']">
                Buy Insurance & License
            </router-link>
            <router-link v-if="!success" :to="`/zinara/vehicles?id=${this.$route.query.id}`"
                         :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']">
                Close
            </router-link>
        </div>

        <div v-if="showAddNewVehicle" class="modal-backdrop opacity-4"></div>
        <div :style="{ display: showAddNewVehicle ? 'block !important' : 'none' }" class="modal" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add Vehicle</h5>
                        <button type="button" class="close"  @click.prevent="showAddNewVehicle = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Vehicle Registration Number</label>
                            <input type="text" class="form-control" v-model="form.vrn"/>
                            <div v-text="form.errors.get('vrn')" class="text-danger"/>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="showAddNewVehicle = false">Close</button>
                        <button type="button" @click="submit"
                                :class="['btn btn-primary' , form.loading || loading ? 'btn-loading' : '']">
                            Add Vehicle
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";

export default {
    name: "dashboard",
    components: {PhoneInput},
    mixins: [validity],
    data: function () {
        return {
            loading: false,
            showUserDetails: true,
            showAddNewVehicle: false,
            fields: [
                'phone'
            ],
            message: null,
            success: false,
            customer: null,
            vehicles: [],
            form: new Form({
                id: this.$route.query.id,
                vrn: '',
                value: '',
            })
        };
    },

    watch: {},

    methods: {

        fetchListOfVehicles() {
            this.loading = true;
            this.form.submit('/zinara/vehicles/list').then((response) => {
                this.loading = false;

                this.success = response.data.success;
                this.message = response.data.message;

                this.form.phone = response.data.body.phone;
                this.vehicles = response.data.body.vehicles;
                this.customer = response.data.body.customer;
            });
        },

        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(this.fields[i], this.form[this.fields[i]]);
            }
        },

        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                let value = localStorage.getItem(this.fields[i]);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },


        submit(event) {
            // Save to Local Storage
            this.message = "";
            if (this.valid) {
                event.preventDefault();
                this.saveToLocalStorage();
                this.form.submit('/zinara/vehicles/create').then((response) => {
                    this.message = response.data.message;
                    this.showAddNewVehicle = false;
                    this.fetchListOfVehicles();
                });
            }
        }
    },

    mounted() {
        this.fetchListOfVehicles();
    }
}
</script>

<style scoped>

</style>
